import React from 'react';
import { materials } from '../data/landing';
export function MaterialsMarquee() {
  const loop = [...materials, ...materials, ...materials, ...materials];
  return <section className="w-full overflow-hidden bg-mint py-16 md:py-20" aria-labelledby="materials-title" data-id="element-118" data-mp="exr5qattciwe">
      <div className="mx-auto max-w-3xl px-5 text-center" data-id="element-119" data-mp="opeshyffdbrj">
        <h2 id="materials-title" className="font-display text-3xl font-bold text-ink md:text-5xl" data-id="element-120" data-mp="opwwjh8bwua0">
          What you'll need
        </h2>
        <p className="mt-3 text-lg font-semibold text-inkSoft" data-id="element-121" data-mp="3s63qux4utf64">
          No robotics kits, no expensive parts — just things you <span className="text-teal" data-id="element-122" data-mp="a10hh07uugzw">already have at home.</span>
        </p>
      </div>
      <div className="relative mt-10" aria-hidden data-id="element-123" data-mp="5z5ezse6txkj">
        <div className="animate-marquee flex w-max gap-4" data-id="element-124" data-mp="5xcaojr1rpfp">
          {loop.map(({
          icon: Icon,
          label
        }, i) => <div key={`${label}-${i}`} className="flex items-center gap-3 rounded-full bg-white px-6 py-3.5 shadow-soft" data-id="element-125" data-mp="1lhqsqxr4xz0d" data-mpi={i}>
              <Icon className="h-6 w-6 text-teal" data-id="element-126" data-mp="2tc3s53yffvse" />
              <span className="font-display text-xl font-semibold text-ink" data-id="element-127" data-mp="2tbbyvzsaya5a">{label}</span>
            </div>)}
        </div>
      </div>
      <ul className="sr-only" data-id="element-128" data-mp="32cs7c1zk426v">
        {materials.map(m => <li key={m.label} data-id="element-129" data-mp="32dl5wfod3ldx">{m.label}</li>)}
      </ul>
    </section>;
}